(function (window) {
  'use strict';

  const header = document.querySelector('.header');
  const headroom = document.querySelector('.headroom');
  const toggles = document.querySelectorAll('[data-header-flyout]');
  const flyout = document.querySelector('.js-header-cart');
  const cartIcon = document.querySelector('.js-header-icon--cart');
  const cartCloseButton = document.querySelector('.js-header-cart-close-button');
  const flyoutOverlay = document.querySelector('.js-header-flyout-overlay');
  const cartOpenClass = 'js-header-cart-open';

  // Events are emitted for flyout actions so that implementation JS can react
  // as needed.
  function emitFlyoutEvent(flyoutId, action) {
    componentEvents.emitEvent('flyout-change', [{
      id: flyoutId,
      action: action
    }]);
  }

  // Allows implementations to toggle whether the cart icon in the header reads
  // as empty or full. Needed as items are added/removed from the cart via Ajax.
  // To-do: implement this as a generic alt icon (i.e. not cart-specific).
  function handleToggleIconEvent(toggle, args) {
    if (args && args.action) {
      const type = toggle.dataset.headerFlyoutType;
      const iconSelectors = [
        '.header-flyout__link--' + type,
        '.header-flyout__button--' + type,
      ];
      const icons = document.querySelectorAll(iconSelectors.join(','));

      Array.prototype.forEach(icons, function (icon) {
        if (args.action == 'full') {
          icon.classList.remove('js-header-flyout-icon-empty-' + type);
        }
        else if (args.action == 'empty') {
          icon.classList.add('js-header-flyout-icon-empty-cart');
        }
      });
    }
  }

  function toggleFlyoutVisibility(event) {
    const toggle = event.currentTarget;
    const type = toggle.dataset.headerFlyoutType;

    if (toggle.getAttribute('aria-expanded') === 'true') {
      closeFlyout(toggle);
    }
    else {
      openFlyout(toggle);
    }
  }

  function openFlyout(toggle, args) {
    args = args || {};
    const type = toggle.dataset.headerFlyoutType;
    const flyout = document.getElementById(toggle.getAttribute('aria-controls'));
    const openerElement = args.openerElement;

    if (flyout) {
      closeAllFlyouts();

      // iOS requires `body { position: fixed }` to prevent background scrolling
      // while the modal is open, which forces the page to jump to the top. The
      // following counteracts that jump. closeFlyout() resets this.
      document.body.dataset.previousScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
      document.body.style.top = (-1 * document.body.dataset.previousScrollTop) + 'px';

      document.body.classList.add('js-header-flyout-' + type + '-open');

      // Handle keydown events to trap focus.
      flyout.addEventListener('keydown', handleKeydown);

      const flyoutClose = flyout.querySelector('.header-flyout__close');
      if (flyoutClose) {
        // Focus on close button.
        flyoutClose.focus();
      }

      if (openerElement) {
        flyout.openerElement = openerElement;
      }

      toggle.setAttribute('aria-expanded', true);
      flyout.setAttribute('aria-hidden', false);

      emitFlyoutEvent(type, 'open');

      // If navigation is open, close it.
      if (window.componentEvents) {
        componentEvents.emitEvent('close-navigation');
      }
    }
  }

  function closeFlyout(toggle, focusBackOnToggle = false) {
    // Since search flyout calls this and not all countries get a cart, check
    // that it exists before proceeding.
    const type = toggle.dataset.headerFlyoutType;
    const flyout = document.getElementById(toggle.getAttribute('aria-controls'));
    if (flyout) {
      // Return the body to its original scroll position before modal was open.
      document.documentElement.scrollTop = document.body.scrollTop = document.body.dataset.previousScrollTop;
      delete document.body.style.top;
      delete document.body.dataset.previousScrollTop;

      document.body.classList.remove('js-header-flyout-' + type + '-open');

      // Remove focus trap.
      flyout.removeEventListener('keydown', handleKeydown);

      if (flyout.openerElement) {
        flyout.openerElement.focus();
        flyout.openerElement = null;
      } else if (focusBackOnToggle) {
        toggle.focus();
      }

      toggle.setAttribute('aria-expanded', false);
      flyout.setAttribute('aria-hidden', true);

      emitFlyoutEvent(type, 'close');
    }
  }

  function closeAllFlyouts() {
    // Find all open flyouts and close them.
    const openToggles = document.querySelectorAll('[data-header-flyout][aria-expanded=true]');
    if (openToggles.length) {
      Array.prototype.forEach.call(openToggles, closeFlyout);
    }
  }

  // Use global modal keydown handler.
  function handleKeydown(event) {
    const toggle = document.getElementById(event.currentTarget.dataset.headerFlyoutToggle);
    const closeFunc = closeFlyout.bind(null, toggle, true);
    handleModalKeydown(event, closeFunc);
  }

  function closeFlyoutAndFocus(toggle) {
    closeFlyout(toggle, true);
  }

  function initFlyoutOverlays() {
    // Attach listener to the document in case the overlay element itself is
    // refreshed or injected via Ajax for some reason.
    document.addEventListener('click', function (event) {
      // Only act if target is flyout overlay.
      if (!event.target.classList.contains('js-header-flyout-overlay')) return;

      closeAllFlyouts();
    });
  }

  // Icons may be replaced in-line after the initial pageload so they can be
  // user-specific on a cached page, so we query the DOM for them again.
  function initToggleAndFlyout(toggle) {
    const flyout = document.getElementById(toggle.getAttribute('aria-controls'));
    if (flyout && !toggle.classList.contains('js-component-init')) {
      // Store reference to toggle in flyout data attr for convenience.
      flyout.dataset.headerFlyoutToggle = toggle.id;

      // Handle clicks on close button within flyout.
      flyout.addEventListener('click', function (event) {
        if (event.target.classList.contains('header-flyout__close')) {
          closeFlyoutAndFocus(toggle);
        }
      });

      toggle.addEventListener('click', toggleFlyoutVisibility);
      toggle.classList.add('js-component-init');
    }
  }

  if (toggles && toggles.length) {
    // Allow application JS to reinitialize any instances added with Ajax, etc.
    Array.prototype.forEach.call(toggles, function (toggle) {
      const type = toggle.dataset.headerFlyoutType;
      if (typeof componentEvents !== 'undefined') {
        componentEvents.on('open-' + type + '-flyout',
          openFlyout.bind(null, toggle));
        componentEvents.on('close-' + type + '-flyout',
          closeFlyout.bind(null, toggle));
        componentEvents.on('change-' + type + '-icon',
          handleToggleIconEvent.bind(null, toggle));
      }
      initToggleAndFlyout(toggle);
    });

    if (typeof componentEvents !== 'undefined') {
      componentEvents.on('close-all-flyouts', closeAllFlyouts);
    }

    initFlyoutOverlays();
  }
})(this);
